module.exports = "https://beta.voredev.ru/assets/index/chat-b06c51372707db33a07caad9d33e1d96.svg";